document.addEventListener("DOMContentLoaded", () => {
  const qrBox = document.getElementById("qr-design-box");
  const radios = document.querySelectorAll('input[name="properties[Front QR Design]"]');

  const urlInput = document.getElementById("qr_url");
  const petForm = document.querySelector(".pet-info-form");

  const petInputs = petForm ? petForm.querySelectorAll("input, textarea") : [];

  const petRequiredSelectors = [
    'input[name="properties[Pet name]"]',
    'input[name="properties[Owner’s Name]"]',
    'input[name="properties[Phone number]"]',
  ];

  const petRequiredInputs = petForm
    ? petRequiredSelectors.map((sel) => petForm.querySelector(sel)).filter(Boolean)
    : [];

  const urlDetails = document.getElementById("qr-url-box");
  const uploadDetails = document.getElementById("qr-upload-box");

  const urlBox =
    urlDetails ||
    (urlInput ? urlInput.closest("details") : null);

  const fileInput = document.getElementById("file_upload");
  const fileNameDisplay = document.getElementById("file_name_display");
  const fileStatus = document.getElementById("file_upload_status");
  const removeFileBtn = document.getElementById("remove_file_button");

  const uploadBox =
    uploadDetails ||
    (fileInput ? fileInput.closest("details") : null);

  // -----------------------------
  // Enter URL optionnel selon collections + pages
  // -----------------------------
  const wrapper = document.querySelector(".custom-design-wrapper");
  const productTitleRaw = wrapper?.dataset?.productTitle || "";
  const collectionTitlesRaw = wrapper?.dataset?.collectionTitles || "";

  const normalize = (s) =>
    (s || "")
      .toLowerCase()
      .replace(/[’']/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const productTitle = normalize(productTitleRaw);
  const collectionTitles = collectionTitlesRaw
    .split("||")
    .map(normalize)
    .filter(Boolean);

  const onAllProductsPage =
    window.location.pathname.toLowerCase().includes("/pages/all-our-products");

  const isSoulmateQuizProduct = productTitle.includes("scan for a soulmate quiz");

  const keywordCollections = ["no scan", "summer", "travel", "patriot", "fun", "hidden"];

  const isInKeywordOptionalCollection = collectionTitles.some((t) =>
    keywordCollections.some((k) => t.includes(k))
  );

  const isTravelLuggageTag = collectionTitles.some((t) => t.includes("luggage tag"));

  // Masquer Enter URL et Upload pour les Travel Luggage Tags
  if (isTravelLuggageTag) {
    if (urlDetails) urlDetails.style.display = "none";
    if (uploadDetails) uploadDetails.style.display = "none";
  }

  const customizeProductCollections = [
    "t-shirt",
    "t shirt",
    "sweatshirt",
    "hoodie",
    "polo",
    "jogger",
    "legging",
    "tote bag",
    "insulated travel mug",
    "tumbler",
    "water bottle",
    "mug",
    "pillow",
    "candle",
    "canvas",
    "framed poster",
    "blanket",
    "tough case",
    "luggage tag",
    "beach towel",
    "notebook",
    "bandana collar",
    "tank top",
    "pet bed",
    "pet food mat",
    "pet bowl",
    "tag",
  ];

  const isCustomizeProduct = collectionTitles.some((t) =>
    customizeProductCollections.some((k) => t === k)
  );

  const isDating = collectionTitles.includes("dating");
  const isFitness = collectionTitles.some((t) => t.includes("fitness"));
  const isBusiness = collectionTitles.some((t) => t.includes("business"));

  // Produits où Enter URL est obligatoire
  const requiredUrlProductHandles = [
    "dating-insulated-travel-mug-scan-to-dm-me",
    "dating-tumbler-black-scan-to-dm-me",
    "dating-tumbler-pink-scan-to-dm-me",
    "dating-mug-black-scan-to-dm-me",
    "dating-mug-pink-scan-to-dm-me",
    "dating-tumbler-white-scan-to-dm-me",
    "dating-hoodie-scan-to-dm-me",
  ];

  // handle produit
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const productHandle = pathParts[0] === "products" ? pathParts[1] : "";

  const isRequiredUrlProduct = requiredUrlProductHandles.includes(productHandle);

  // Flag final
  const enterUrlOptional =
    !isRequiredUrlProduct &&
    (
      onAllProductsPage ||
      (isInKeywordOptionalCollection && !isTravelLuggageTag) ||
      isCustomizeProduct ||
      isFitness ||
      isBusiness ||
      (isDating && isSoulmateQuizProduct)
    );

  // -----------------------------
  // Pet special rules (message variants)
  // -----------------------------
  const specialPetHandles = [
    "tag-white",
    "bandana-collar-white",
    "top-white",
    "pet-bed-white",
    "pet-food-mat",
    "pet-bowl-white",
  ];

  const isToughCase = collectionTitles.some((t) => t.includes("tough case"));
  const isLuggageTagProduct = productHandle === "luggage-tag";
  const isSpecialPetProduct = isToughCase || specialPetHandles.includes(productHandle);

  // -----------------------------
  // Helpers UI
  // -----------------------------
  const setError = (detailsEl, on) => {
    if (!detailsEl) return;
    detailsEl.classList.toggle("qr-error", !!on);
  };

  const openDetails = (detailsEl) => {
    if (!detailsEl) return;
    if (!detailsEl.hasAttribute("open")) detailsEl.setAttribute("open", "");
  };

  const shake = (btn) => {
    if (!btn) return;
    btn.classList.remove("qr-shake");
    void btn.offsetWidth;
    btn.classList.add("qr-shake");
    setTimeout(() => btn.classList.remove("qr-shake"), 600);
  };

  const isVisible = (el) => !!el && el.offsetParent !== null;

  // -----------------------------
  // Error message (above Buy it now)
  // -----------------------------
  const BUSINESS_MSG_ID = "business-oneof-error";

  const ensureBusinessMsgEl = (btn) => {
    if (!btn) return null;

    // Only for Buy it now (not add to cart)
    const isBuyNow =
      btn.matches("#buy_it_now_button") ||
      btn.classList.contains("shopify-payment-button__button");

    if (!isBuyNow) return null;

    let el = document.getElementById(BUSINESS_MSG_ID);
    if (el) return el;

    el = document.createElement("div");
    el.id = BUSINESS_MSG_ID;
    el.style.display = "none";
    el.style.margin = "10px 0";
    el.style.color = "#ff0000";
    el.style.fontSize = "13px";
    el.style.fontWeight = "600";

    btn.parentNode.insertBefore(el, btn);
    return el;
  };

  const setMsg = (btn, on, text) => {
    const el = ensureBusinessMsgEl(btn);
    if (!el) return;
    el.textContent = text || "";
    el.style.display = on ? "block" : "none";
  };

  const hideMsgIfAny = () => {
    const el = document.getElementById(BUSINESS_MSG_ID);
    if (!el) return;
    el.style.display = "none";
  };

  const MSG_URL_FILE =
    'Please fill in one of the following fields: "Enter URL" or "Upload your file".';

  const MSG_URL_FILE_OR_PET =
    'Please fill in one of the following fields: "Enter URL" or "Upload your file" or "Scan Me If I\'m Lost" form.';

  const MSG_PET_ONLY =
    'Please complete the "Scan Me If I\'m Lost" required fields.';

  // -----------------------------
  // Pet UI errors: only required inputs
  // -----------------------------
  const REQUIRED_HINT_CLASS = "qr-required-hint";

  const setPetFormErrorOutline = (on) => {
    if (!petForm) return;
    petForm.style.outline = on ? "2px solid #ff0000" : "";
    petForm.style.outlineOffset = on ? "6px" : "";
    petForm.style.borderRadius = "12px";
  };

  const setRequiredInputError = (input, on) => {
    if (!input) return;

    input.classList.toggle("qr-error-input", !!on);
    input.style.borderColor = on ? "#ff0000" : "";
    input.style.boxShadow = on ? "0 0 0 1px #ff0000" : "";

    let hint = input.nextElementSibling;
    const hintIsOurs = hint && hint.classList && hint.classList.contains(REQUIRED_HINT_CLASS);

    if (!hintIsOurs) {
      hint = document.createElement("div");
      hint.className = REQUIRED_HINT_CLASS;
      hint.textContent = "Required field";
      hint.style.display = "none";
      hint.style.color = "#ff0000";
      hint.style.fontStyle = "italic";
      hint.style.fontSize = "13px";
      hint.style.marginTop = "6px";
      input.insertAdjacentElement("afterend", hint);
    }

    hint.style.display = on ? "block" : "none";
  };

  const clearPetRequiredErrors = () => {
    setPetFormErrorOutline(false);
    petRequiredInputs.forEach((i) => setRequiredInputError(i, false));
  };

  // -----------------------------
  // Exclusivité Pet <-> URL <-> Upload
  // -----------------------------
  const isPetFormFilled = () =>
    Array.from(petInputs).some((i) => i.value.trim().length > 0);

  const disablePetForm = () => {
    petInputs.forEach((i) => {
      i.value = "";
      i.disabled = true;
      i.classList.remove("qr-error-input");
    });
    if (petForm) {
      petForm.classList.add("qr-disabled");
      petForm.classList.remove("qr-error");
    }
  };

  const enablePetForm = () => {
    petInputs.forEach((i) => {
      i.disabled = false;
    });
    if (petForm) petForm.classList.remove("qr-disabled");
  };

  const disableUrlAndFile = () => {
    if (urlInput) {
      urlInput.value = "";
      urlInput.disabled = true;
      setError(urlBox, false);
    }
    if (fileInput) {
      fileInput.value = "";
      fileInput.disabled = true;
    }
    if (fileNameDisplay) fileNameDisplay.textContent = "No file selected";
    if (fileStatus) {
      fileStatus.style.display = "none";
      fileStatus.textContent = "";
    }
    // ✅ NEW: also hide remove button when URL/file are disabled
    if (removeFileBtn) removeFileBtn.style.display = "none";

    if (urlDetails) urlDetails.classList.add("qr-disabled");
    if (uploadDetails) uploadDetails.classList.add("qr-disabled");
  };

  const enableUrlAndFile = () => {
    if (urlInput) urlInput.disabled = false;
    if (fileInput) fileInput.disabled = false;
    if (urlDetails) urlDetails.classList.remove("qr-disabled");
    if (uploadDetails) uploadDetails.classList.remove("qr-disabled");
  };

  // -----------------------------
  // Validation
  // -----------------------------
  const validateAll = (clickedBtn) => {
    let ok = true;

    const usingPet = !!petForm && isPetFormFilled();

    const petOk =
      !!petForm &&
      petRequiredInputs.length > 0 &&
      petRequiredInputs.every((i) => i.value.trim().length > 0);

    // QR Design Position obligatoire seulement si radios présents
    const hasRadios = radios.length > 0;
    const designSelected = !hasRadios ? true : Array.from(radios).some((r) => r.checked);

    setError(qrBox, !designSelected);
    if (!designSelected) {
      ok = false;
      openDetails(qrBox);
    }

    // Enter URL obligatoire si:
    const mustValidateUrl = !!urlInput && isVisible(urlInput) && !enterUrlOptional && !usingPet;
    const urlFilled = !mustValidateUrl ? true : urlInput.value.trim().length > 0;

    setError(urlBox, mustValidateUrl && !urlFilled);
    if (mustValidateUrl && !urlFilled) {
      ok = false;
      openDetails(urlBox);
    }

    // 1) Luggage-tag: ONLY Scan Me If I'm Lost required
    if (isLuggageTagProduct && petForm) {
      if (!petOk) {
        ok = false;

        petRequiredInputs.forEach((input) => {
          const valid = input.value.trim().length > 0;
          setRequiredInputError(input, !valid);
        });

        setPetFormErrorOutline(true);
        setMsg(clickedBtn, true, MSG_PET_ONLY);
      } else {
        clearPetRequiredErrors();
        setMsg(clickedBtn, false, "");
      }
    }

    // 2) Tough case + specific pet handles: URL OR File OR Pet form
    if (!isLuggageTagProduct && isSpecialPetProduct) {
      const urlOk = !!urlInput && urlInput.value.trim().length > 0;
      const fileOk = !!fileInput && !!fileInput.files && fileInput.files.length > 0;
      const oneOfOk = urlOk || fileOk || petOk;

      if (!oneOfOk) {
        ok = false;

        if (urlInput && isVisible(urlInput)) {
          setError(urlBox, true);
          openDetails(urlBox);
        }
        if ((fileInput && isVisible(fileInput)) || (uploadBox && isVisible(uploadBox))) {
          setError(uploadBox, true);
          openDetails(uploadBox);
        }

        if (petForm) {
          petRequiredInputs.forEach((input) => setRequiredInputError(input, true));
          setPetFormErrorOutline(true);
        }
        setMsg(clickedBtn, true, MSG_URL_FILE_OR_PET);
      } else {
        setError(urlBox, false);
        setError(uploadBox, false);
        clearPetRequiredErrors();
        setMsg(clickedBtn, false, "");
      }
    }

    // 3) Default: URL OR File for Business + Customize products
    const needsOneOf =
      (isBusiness || isCustomizeProduct) &&
      enterUrlOptional &&
      !isTravelLuggageTag &&
      !usingPet &&
      !!urlInput &&
      !!fileInput &&
      isVisible(urlInput) &&
      (isVisible(fileInput) || isVisible(uploadBox)) &&
      !isLuggageTagProduct &&
      !isSpecialPetProduct;

    if (needsOneOf) {
      const urlOk = urlInput.value.trim().length > 0;
      const fileOk = !!fileInput.files && fileInput.files.length > 0;
      const oneOfOk = urlOk || fileOk;

      setError(urlBox, !oneOfOk);
      setError(uploadBox, !oneOfOk);

      if (!oneOfOk) {
        ok = false;
        openDetails(urlBox);
        openDetails(uploadBox);
        setMsg(clickedBtn, true, MSG_URL_FILE);
      } else {
        setMsg(clickedBtn, false, "");
      }
    } else {
      if (!isLuggageTagProduct && !isSpecialPetProduct) {
        setMsg(clickedBtn, false, "");
      }
    }

    // Validation Pet uniquement si utilisé (cas générique)
    if (usingPet && !isLuggageTagProduct) {
      petRequiredInputs.forEach((input) => {
        const valid = input.value.trim().length > 0;
        setRequiredInputError(input, !valid);
        if (!valid) ok = false;
      });

      if (!petOk) setPetFormErrorOutline(true);
    }

    // Scroll vers première erreur
    if (!ok) {
      const first =
        (!designSelected && qrBox) ? qrBox :
        (mustValidateUrl && !urlFilled && urlBox) ? urlBox :
        ((isLuggageTagProduct && petForm && !petOk) ? petForm : null) ||
        ((!isLuggageTagProduct && isSpecialPetProduct && petForm && !petOk) ? petForm : null) ||
        (needsOneOf && urlBox) ? urlBox :
        null;

      if (first && typeof first.scrollIntoView === "function") {
        first.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }

    return ok;
  };

  // -----------------------------
  // Upload file status
  // -----------------------------
  if (fileInput && fileNameDisplay && fileStatus) {
    const MAX_BYTES = 50 * 1024 * 1024;
    const allowedExt = ["pdf", "jpg", "jpeg", "png", "mp3", "mp4", "mov"];

    const hideStatus = () => {
      fileStatus.style.display = "none";
      fileStatus.textContent = "";
    };

    const showSuccess = () => {
      fileStatus.textContent = "File uploaded successfully !";
      fileStatus.style.display = "block";
      fileStatus.style.color = "#1f6b3a";
    };

    const showError = (msg) => {
      fileStatus.textContent = msg;
      fileStatus.style.display = "block";
      fileStatus.style.color = "#8a1f1f";
    };

    // ✅ NEW: helper to toggle remove button
    const setRemoveBtnVisible = (on) => {
      if (!removeFileBtn) return;
      removeFileBtn.style.display = on ? "inline-block" : "none";
    };

    hideStatus();
    // ✅ NEW: ensure hidden by default
    setRemoveBtnVisible(false);

    fileInput.addEventListener("change", () => {
      hideStatus();

      const f = fileInput.files && fileInput.files[0];
      if (!f) {
        fileNameDisplay.textContent = "No file selected";
        // ✅ NEW
        setRemoveBtnVisible(false);
        return;
      }

      const name = f.name || "file";
      const ext = (name.split(".").pop() || "").toLowerCase();

      if (!allowedExt.includes(ext)) {
        showError("Invalid file format. Please upload: PDF, JPG, PNG, MP3, MP4, MOV.");
        fileInput.value = "";
        fileNameDisplay.textContent = "No file selected";
        // ✅ NEW
        setRemoveBtnVisible(false);
        return;
      }

      if (f.size > MAX_BYTES) {
        showError("File is too large. Max size is 50 MB.");
        fileInput.value = "";
        fileNameDisplay.textContent = "No file selected";
        // ✅ NEW
        setRemoveBtnVisible(false);
        return;
      }

      fileNameDisplay.textContent = name;
      showSuccess();

      // ✅ NEW: show remove button when file is valid
      setRemoveBtnVisible(true);

      hideMsgIfAny();
      setError(urlBox, false);
      setError(uploadBox, false);
      clearPetRequiredErrors();
    });

    if (removeFileBtn) {
      removeFileBtn.addEventListener("click", () => {
        fileInput.value = "";
        fileNameDisplay.textContent = "No file selected";
        hideStatus();

        // ✅ NEW: hide remove button after removing file
        setRemoveBtnVisible(false);

        hideMsgIfAny();
        setError(urlBox, false);
        setError(uploadBox, false);
        clearPetRequiredErrors();

        // Déclenche sync via l'event déjà branché plus bas
        fileInput.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }
  }

  // -----------------------------
  // Sync exclusivité
  // -----------------------------
  const petFilled = () => Array.from(petInputs).some((i) => i.value.trim().length > 0);
  const urlFilledNow = () => !!urlInput && urlInput.value.trim().length > 0;
  const fileFilledNow = () => !!fileInput && !!fileInput.files && fileInput.files.length > 0;

  const sync = () => {
    if (isTravelLuggageTag) return;

    const petIsUsed = petFilled();
    const urlIsUsed = urlFilledNow();
    const fileIsUsed = fileFilledNow();

    enablePetForm();
    enableUrlAndFile();

    if (petIsUsed) {
      disableUrlAndFile();
      return;
    }

    if (!enterUrlOptional) {
      if (uploadDetails) uploadDetails.classList.add("qr-disabled");

      if (fileInput) {
        if (fileInput.files && fileInput.files.length > 0) {
          fileInput.value = "";
          if (fileNameDisplay) fileNameDisplay.textContent = "No file selected";
          if (fileStatus) {
            fileStatus.style.display = "none";
            fileStatus.textContent = "";
          }
        }
        fileInput.disabled = true;
      }

      // ✅ NEW: also hide remove button if upload is forced-disabled
      if (removeFileBtn) removeFileBtn.style.display = "none";

      if (urlIsUsed) {
        disablePetForm();
      }

      return;
    }

    if (urlIsUsed) {
      disablePetForm();

      if (uploadDetails) uploadDetails.classList.add("qr-disabled");
      if (fileInput) {
        fileInput.value = "";
        fileInput.disabled = true;
      }
      if (fileNameDisplay) fileNameDisplay.textContent = "No file selected";
      if (fileStatus) {
        fileStatus.style.display = "none";
        fileStatus.textContent = "";
      }
      // ✅ NEW
      if (removeFileBtn) removeFileBtn.style.display = "none";
      return;
    }

    if (fileIsUsed) {
      disablePetForm();

      if (urlDetails) urlDetails.classList.add("qr-disabled");
      if (urlInput) {
        urlInput.value = "";
        urlInput.disabled = true;
        setError(urlBox, false);
      }
      return;
    }
  };

  // Pet inputs: hide message as soon as user starts typing
  petInputs.forEach((input) =>
    input.addEventListener("input", () => {
      hideMsgIfAny();
      clearPetRequiredErrors();
      setError(urlBox, false);
      setError(uploadBox, false);
      sync();
    })
  );

  if (urlInput) {
    urlInput.addEventListener("input", () => {
      hideMsgIfAny();
      setError(urlBox, false);
      setError(uploadBox, false);
      clearPetRequiredErrors();
      sync();
    });
  }

  if (fileInput) fileInput.addEventListener("change", sync);

  // Empêche l'ouverture des blocs désactivés
  document.addEventListener("click", (e) => {
    const summary = e.target.closest("summary");
    if (!summary) return;
    const details = summary.closest("details");
    if (details && details.classList.contains("qr-disabled")) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // -----------------------------
  // Clear erreurs en live
  // -----------------------------
  radios.forEach((r) => r.addEventListener("change", () => setError(qrBox, false)));

  if (urlInput) {
    urlInput.addEventListener("input", () => {
      if (!enterUrlOptional) setError(urlBox, false);
    });
  }

  // -----------------------------
  // Interception achat + shake
  // -----------------------------
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(
      "#buy_it_now_button, .shopify-payment-button__button, button[name='add']"
    );
    if (!btn) return;

    const cartForm = btn.closest("form[action*='/cart/add']");
    if (!cartForm) return;

    if (!qrBox && !urlInput && !petForm && !fileInput) return;

    const ok = validateAll(btn);
    if (!ok) {
      e.preventDefault();
      e.stopPropagation();
      shake(btn);
    }
  }, true);

  // Initial sync
  sync();
});

document.addEventListener("DOMContentLoaded", () => {
  const qrTextInput = document.getElementById("qr_text");
  const charCount = document.getElementById("char-count");
  const previewBox = document.getElementById("preview-box");
  const fontSelect = document.getElementById("font-select");

  if (!qrTextInput || !charCount || !previewBox) return;

  const maxLength = qrTextInput.maxLength || 50;

  const updatePreview = () => {
    const text = qrTextInput.value || "";

    // Character counter
    charCount.textContent = `${text.length} / ${maxLength} characters`;

    // Live preview text
    previewBox.textContent = text.length
      ? text
      : "Your text will appear here...";

    // Apply selected font
    if (fontSelect) {
      previewBox.style.fontFamily = fontSelect.value;
    }
  };

  qrTextInput.addEventListener("input", updatePreview);

  if (fontSelect) {
    fontSelect.addEventListener("change", updatePreview);
  }

  // Initial state
  updatePreview();
});


document.addEventListener("DOMContentLoaded", () => {
  const urlInput = document.getElementById("qr_url");
  const clearUrlBtn = document.getElementById("clear_url_button");

  if (!urlInput || !clearUrlBtn) return;

  const toggleBtn = () => {
    const hasValue = urlInput.value.trim().length > 0;
    clearUrlBtn.style.display = hasValue ? "inline-block" : "none";
  };

  // Show/hide on typing
  urlInput.addEventListener("input", toggleBtn);

  // Clear instantly
  clearUrlBtn.addEventListener("click", () => {
    urlInput.value = "";

    // Trigger your existing listeners (sync(), error clearing, etc.)
    urlInput.dispatchEvent(new Event("input", { bubbles: true }));

    toggleBtn();
  });

  // Initial state
  toggleBtn();
});



document.addEventListener("DOMContentLoaded", () => {
  const withRadio = document.querySelector(
    'input[name="properties[Front QR Design]"][value="with"]'
  );
  const withoutRadio = document.querySelector(
    'input[name="properties[Front QR Design]"][value="without"]'
  );
  const note = document.getElementById("with-surcharge-note");

  if (!withRadio || !withoutRadio) return;

  // ✅ Your surcharge variant ID
  const SURCHARGE_VARIANT_ID = 56187562164610;

  // Create a unique id per product-page session (links main item ↔ surcharge item)
  const qrLinkId = `qr_${Date.now()}_${Math.random().toString(16).slice(2)}`;
  const productUrl = window.location.href;

  // Ensure the main product form carries the link id + Product Link as line item properties
  const productForm =
    document.querySelector('form[action^="/cart/add"]') ||
    document.querySelector('form[action="/cart/add"]');

  if (productForm) {
    const ensureHidden = (name, id, value) => {
      let el = productForm.querySelector(`#${id}`);
      if (!el) {
        el = document.createElement("input");
        el.type = "hidden";
        el.name = name;
        el.id = id;
        productForm.appendChild(el);
      }
      el.value = value;
    };

    // ✅ Keep internal link id (used for matching)
    ensureHidden("properties[_qr_link_id]", "qr_link_id_input", qrLinkId);

    // ✅ Rename label to "Product Link"
    ensureHidden("properties[Product Link]", "qr_product_url_input", productUrl);
  }

  const getCart = async () => {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    return res.json();
  };

  const addSurcharge = async () => {
    // Add surcharge WITH properties that identify the parent product
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        id: SURCHARGE_VARIANT_ID,
        quantity: 1,
        properties: {
          _qr_link_id: qrLinkId,      // internal matcher
          "Product Link": productUrl  // visible label
        },
      }),
    });
  };

  const removeSurcharge = async (cart) => {
    // Remove ONLY the surcharge item that matches this page’s link id
    const surchargeItem = cart.items.find((i) => {
      return (
        i.variant_id === SURCHARGE_VARIANT_ID &&
        i.properties &&
        i.properties._qr_link_id === qrLinkId
      );
    });

    if (!surchargeItem) return;

    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ line: surchargeItem.line, quantity: 0 }),
    });
  };

  const syncSurcharge = async () => {
    const wantsSurcharge = withRadio.checked;
    const cart = await getCart();

    const hasThisSurcharge = cart.items.some((i) => {
      return (
        i.variant_id === SURCHARGE_VARIANT_ID &&
        i.properties &&
        i.properties._qr_link_id === qrLinkId
      );
    });

    if (wantsSurcharge && !hasThisSurcharge) {
      await addSurcharge();
      return;
    }

    if (!wantsSurcharge && hasThisSurcharge) {
      await removeSurcharge(cart);
      return;
    }
  };

  // UI note toggle
  const updateNote = () => {
    if (note) note.style.display = withRadio.checked ? "block" : "none";
  };

  withRadio.addEventListener("change", () => {
    updateNote();
    if (withRadio.checked) syncSurcharge();
  });

  withoutRadio.addEventListener("change", () => {
    updateNote();
    if (withoutRadio.checked) syncSurcharge();
  });

  // Initial state
  updateNote();
  syncSurcharge();
});
